import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import "../Styles/Admin.css";
import AddImg from "../Assets/Images/AddImg.png";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import AdminProfileImg from "../Assets/Images/AdminProfile.png";
import InActiveIcon from "../Assets/Icons/inActiveIcon.svg"

export default function AdminProfileInActive() {
  const notify = () => toast.info("Changes Saved!");
  return (
    <Container fluid>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PageLayout>
        <div>
          <div className="create-admin-card-con">
            <Card className="profile-admin-card">
              <div className="admin-active-header-parent">
                <div className="admin-active-header-con">
                  <img src={AdminProfileImg} />
                  <div className="merchant-email-heading">
                    <h4>Admin name</h4>
                    <div className="merchant-active-status">
                      <img
                        style={{ width: "1rem", height: "1rem" }}
                        src={InActiveIcon}
                      />
                      <h5>Inactive</h5>
                    </div>
                  </div>
                </div>
                <div className="admin-active-btn">
                  <Button variant="danger">Active</Button>
                  <Button variant="dark">Send Mail</Button>
                </div>
              </div>
              <div className="admin-active-divider"></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div style={{ width: "70%" }} className="create-admin-content">
                  <div className="add-admin-inputs">
                    <div className="add-admin-form">
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          First Name
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="text"
                          placeholder="First name"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Last Name
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="text"
                          placeholder="Last name"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Email
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="email"
                          placeholder="info@email.com"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Zip code
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="number"
                          placeholder="zip code"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Address
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="text"
                          placeholder="Islamabad, Pakistan"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Shop address
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="text"
                          placeholder="Islamabad, pakistan"
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasic">
                        <Form.Label style={{ color: "#27293D" }}>
                          Phone
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="number"
                          placeholder="+923160598938"
                        />
                      </Form.Group>
                    </div>
                    <div className="add-admin-btns">
                      <Button variant="outline-dark">Cancel</Button>
                      <Button onClick={notify} variant="primary">
                        Save changes
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
